import { ReactNode } from 'react';
import styles from './ProgressBar.module.css';
import cn from 'clsx';

export interface ProgressBarProps {
    progress: number;
    children?: ReactNode;
    className?: string;
    [rest: string]: any;
}
export const ProgressBar = ({ progress, children, className, ...rest }: ProgressBarProps) => {
    const progress_bar = cn(styles.progress_bar, className);
    return (
        <div className={progress_bar}>
            <div className={styles.progress_wrapper}>
                <progress max={100} className={styles.progress} value={Math.max(3, progress || 0)} {...rest}>
                </progress>
                <div className={styles.progress_text}>
                    {children}
                </div>
            </div>
        </div>
    )
}